/* eslint-disable react-hooks/exhaustive-deps */
import './ViewGeneralQuestions.scss';
import React, {useMemo, useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {FmlxToggleButton} from 'fmlx-common-ui';
import {ManageQuestionContext} from '../../lib/contexLib';
import {ACTIVE_TAB, ALERT_VARIANT, EResponseCode} from '../../const/dataEnum';
import {setAlert} from '../../stores/actions/alertModalStateAction';
import PracticeDropdown from '../../components/CommonDropdown/PracticeDropdown';
import DepartmentDropdown from '../../components/CommonDropdown/DepartmentDropdown';
import NavTabs from './ManageQuestion/NavTabs';
import NavContent from './ManageQuestion/NavContent';
import genericReviewQuestionApi from '../../api/rest/genericReviewQuestionApi';
import useDepartment from '../../hooks/useDepartment';
import useEffectWithDebounce from '../../hooks/useEffectWithDebounce';
import {selectPeriodeAndAuthRole} from '../../stores/selectors/appStateSelector';
import skillCategoryApi from '../../api/rest/skillCategoryApi';
import skillApi from '../../api/rest/skillApi';
import {setSelectedPractice as setSelectedPracticeRedux} from '../../stores/actions/practiceAction';

export const ACTIVE_CATEGORY = {GENERAL: 'General', SKILL: 'Skill'};

const ViewGeneralQuestions = () => {
  const userDepartmentId = useSelector((s) => s.appState.user.departmentID, shallowEqual);
  const {currentPeriodId} = useSelector(selectPeriodeAndAuthRole);
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const [subPeriod, setSubPeriod] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(currentPeriodId);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedPractice, setSelectedPractice] = useState(null);
  const departments = useDepartment();
  const [renameTabId, setRenameTabId] = useState(null);

  if (selectedDepartment === null && departments.length > 0) {
    const selectedDepartment = departments.find((dprt) => dprt.id === userDepartmentId);
    if (selectedDepartment) {
      setSelectedDepartment(selectedDepartment.value);
    }
  }

  const [tabs, setTabs] = useState([
    {
      id: 0,
      category: ACTIVE_TAB.GENERAL,
      categoryOrder: 0,
      description: '',
      notes: ACTIVE_TAB.GENERAL.toLowerCase(),
      active: false,
    },
  ]);
  const [activeTab, setActiveTab] = useState();
  const [activeTabQuestion, setActiveTabQuestion] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [generalQuestions, setGeneralQuestions] = useState([]);
  const [activeCategory, setActiveCategory] = useState(0);

  const toggleButtonItems = [
    {text: ACTIVE_CATEGORY.GENERAL, icon: <></>, disabled: false},
    {text: ACTIVE_CATEGORY.SKILL, icon: <></>, disabled: false},
  ];

  useEffectWithDebounce(() => {
    setAllTabs();
  }, [selectedPeriod, selectedDepartment, selectedPractice, activeCategory, currentPeriodId]);

  useEffectWithDebounce(() => {
    handleTabsData(selectedDepartment?.id);
  }, [activeTab, tabs, currentPeriodId]);

  const setAllTabs = async () => {
    let gen = {
      id: 0,
      category: ACTIVE_TAB.GENERAL,
      categoryOrder: 0,
      description: '',
      notes: ACTIVE_TAB.GENERAL.toLowerCase(),
      active: true,
    };
    let tabsData = [];

    if (toggleButtonItems[activeCategory].text !== ACTIVE_CATEGORY.GENERAL) {
      if (!selectedPractice?.id) {
        setTabs([]);
        setActiveTab(undefined);
        setActiveTabQuestion([]);
        return;
      }
      const tabsResult = await skillCategoryApi.getByPracticeAndPeriodId(selectedPractice?.id, currentPeriodId);
      if (tabsResult.responseCode === EResponseCode.NO_ERROR) {
        const sortedTabs = tabsResult?.data.sort((a, b) => (a.categoryOrder || 0) - (b.categoryOrder || 0));
        
        tabsData = sortedTabs.map((tab, index) => ({
          id: tab.id,
          category: tab.category,
          categoryOrder: tab.categoryOrder || (index + 1),
          description: tab.description,
          notes: tab.notes,
          departments: tab.departments,
          practice: tab.practice,
          practiceId: tab.practiceId,
          active: index === 0,
        }));
        // tabsData.unshift(gen);
        if (tabsData.length > 0) {
          setActiveTab(tabsData[0]);
        }
      } else {
        tabsData = [];
        setActiveTab(undefined);
        setActiveTabQuestion([]);
      }
    } else {
      tabsData = [gen];
      setActiveTab(gen);
    }
    setTabs(tabsData);
  };
  const handleTabsData = async (departmentId) => {
    if (tabs.length === 0) return;
    let findActive = tabs.find((tab) => tab.active === true);

    // fetch skill question
    if (toggleButtonItems[activeCategory].text !== ACTIVE_CATEGORY.GENERAL && tabs.length > 0) {
      const data = allQuestions.find((allQues) => allQues.categoryId === findActive?.id);

      if (selectedPractice && selectedPeriod) {
        const response = await skillApi.getByCategory(selectedPractice.id, currentPeriodId, findActive?.id);
        if (response.responseCode === EResponseCode.NO_ERROR) {
          let sortedQuestions = response.data.sort((a, b) => a.orderNumber - b.orderNumber);
          let ques = {...data, question: sortedQuestions};
          let tempQuestions = allQuestions.map((quest) => (quest.categoryId === findActive.id ? ques : quest));

          setAllQuestions(tempQuestions);
          setActiveTabQuestion(sortedQuestions);
        } else if (response.responseCode === EResponseCode.ITEM_NOT_FOUND) {
          // "No Skill found"
          let ques = {...data, question: []};
          let tempQuestions = allQuestions.map((quest) => (quest.categoryId === findActive.id ? ques : quest));

          setAllQuestions(tempQuestions);
          setActiveTabQuestion([]);
        } else {
          dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: response.message}));
        }
      } else {
        setAllQuestions([]);
        setActiveTabQuestion([]);
      }
      return;
    }

    // fetch general question
    if (!departmentId) return;
    let sortedQuestions = [];
    const data = await genericReviewQuestionApi.getAllQuestionByPeriodAndDepartement(departmentId, currentPeriodId);
    if (data) {
      sortedQuestions = data.sort((a, b) => a.orderNumber - b.orderNumber);
      setGeneralQuestions(sortedQuestions);
    }
    let questionTabDescription = tabs.map((da) =>
      da.category === ACTIVE_TAB.GENERAL
        ? {
            name: da.category,
            categoryId: da.id,
            question: sortedQuestions,
          }
        : {
            name: da.category,
            categoryId: da.id,
            question: undefined,
          }
    );
    setActiveTabQuestion(sortedQuestions);
    setAllQuestions(questionTabDescription);
  };

  const addNewTab = async (payload) => {
    try {
      const response = await skillCategoryApi.create(selectedDepartment.id, currentPeriodId, payload);
      const updatedTabs = tabs.length === 0 ? [{...payload, active: true}] : [...tabs, {...payload, active: false}];
      setTabs(updatedTabs);
      setAllTabs();
      setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: response.message})
    } catch (error) {
      dispatch(
        setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: error.message})
      );
    }
  };

  const handleChangeCategory = (selectedButtonId) => {
    setActiveCategory(selectedButtonId);
    setSelectedDepartment(null);
    setSelectedPractice(null);
    dispatch(setSelectedPracticeRedux(null));
    setActiveTabQuestion([]);
    setTabs([]);
  };

  const memoizedNavContentComponent = useMemo(() => {
    return (
      <NavContent
        isGeneral={toggleButtonItems[activeCategory]?.text === ACTIVE_CATEGORY.GENERAL}
        fetchTabs={setAllTabs}
      />
    );
  }, [activeTab, activeCategory, activeTabQuestion, allQuestions]);
  const memoizedNavTabsComponent = useMemo(
    () => <NavTabs data={tabs} addNewTab={addNewTab} fetchTabs={setAllTabs} reviewPeriodId={currentPeriodId}/>,
    [tabs, addNewTab, currentPeriodId]
  );
  const memoizedFilterComponent = useMemo(
    () => (
      <div className="filterBar">
        {/* <FilterIcon /> */}
        {/* <PeriodDropdown
          callbackChangePeriod={(value) => {
            setSelectedPeriod(value);
          }}
          periodValue={selectedPeriod}
        /> */}
        <DepartmentDropdown
          callbackChangeDepartment={(value) => {
            setSelectedDepartment(value);
          }}
          departmentValue={selectedDepartment}
        />
        <PracticeDropdown
          callbackChangePractice={(value) => {
            setSelectedPractice(value);
          }}
          department={selectedDepartment}
          practiceValue={selectedPractice}
        />
        {/* hide submision period and save button because there is no action to save to BE */}
        {/* <div style={{ display: "flex", alignItems: "center", gap: "16px", marginLeft: "auto" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              border: "1px solid #AAAAAA",
              borderRadius: "4px",
              padding: "8px",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <div>Submission Period</div>
            <label className="switch">
              <input type="checkbox" onChange={(e) => setSubPeriod(true)} value={subPeriod} />
              <span className="slider round"></span>
            </label>
          </div>
          <FmlxButton
            size={FMLX_COMPONENT.SIZE.M}
            type={FMLX_BUTTON.TYPE.PRIMARY}
            variant={FMLX_BUTTON.VARIANT.CONTAIN}
            disabled={selectedPractice === undefined || selectedPeriod === null || selectedDepartment === undefined}
            label="SAVE"
            onClick={handleSave}
            withIcon={FMLX_BUTTON.WITH_ICON.START}
            icon={<SaveIcon />}
          ></FmlxButton>
        </div> */}
      </div>
    ),
    [subPeriod, selectedPeriod, selectedDepartment, selectedPractice]
  );
  return (
    <div className="pageWrapper manageQuestionPage">
      <ManageQuestionContext.Provider
        value={{
          // subPeriod,
          // setSubPeriod,
          selectedPeriod,
          setSelectedPeriod,
          selectedDepartment,
          setSelectedDepartment,
          selectedPractice,
          setSelectedPractice,
          activeTab,
          setActiveTab,
          tabs,
          setTabs,
          allQuestions,
          setAllQuestions,
          generalQuestions,
          setGeneralQuestions,
          activeTabQuestion,
          setActiveTabQuestion,
          handleTabsData,
          departments,
          renameTabId,
          setRenameTabId,
          setAllTabs,
        }}
      >
        <div className="manageQuestionPage-toggleButton">
          <FmlxToggleButton value={activeCategory} items={toggleButtonItems} onChange={handleChangeCategory} />
        </div>
        <div
          className="manageQuestionPage-content"
          style={
            toggleButtonItems[activeCategory]?.text === ACTIVE_CATEGORY.GENERAL
              ? {}
              : {display: 'grid', gridTemplateRows: 'max-content max-content auto'}
          }
        >
          {toggleButtonItems[activeCategory]?.text === ACTIVE_CATEGORY.SKILL && (
            <>
              {memoizedFilterComponent}
              {memoizedNavTabsComponent}
            </>
          )}
          {memoizedNavContentComponent}
        </div>
      </ManageQuestionContext.Provider>
    </div>
  );
};

export default ViewGeneralQuestions;
